module.exports = __webpack_public_path__ + "img/Russia.aa4f84b3.png";